import request from "_private/utils/request";

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
  return request({
    url: "/base/vehicle/findByPage",
    method: "post",
    data
  });
}

/**
 * 初始化门店冷柜树
 */
export function FetchVehicleTree() {
  return request({
    url: "/base/vehicle/getVehicleInfoTree",
    method: "post"
  });
}
/**
 * 删除车辆信息
 * @param {*} data
 */
export function DeleteDataById(data) {
  return request({
    url: "/base/vehicle/deleteVehicleInfoByIds",
    method: "post",
    data
  });
}

/**
 * 编辑车辆信息
 * @param {*} data
 */
export function SaveVehicleInfo(data) {
  return request({
    url: "/base/vehicle/saveVehicleInfo",
    method: "post",
    data
  });
}

/**
 * 查询单个车辆信息
 * @param {*} data
 */
export function FindVehicleInfoById(data) {
  return request({
    url: "/base/vehicle/findVehicleInfoById",
    method: "post",
    data
  });
}

export function getVehicleInfoTreeForNew(data) {
  return request({
    url: "/base/vehicle/getVehicleInfoTreeForNew",
    method: "post",
    data
  });
}
